import { UpdateUploadDtoStateEnum, UploadDto } from "generated";
import Text from "@ingka/text";
import { formatDateTime } from "@/utils/misc";

type Props = {
  upload: UploadDto;
  adminPage?: boolean;
  children?: React.ReactNode;
};

const UploadTitle = ({ upload, adminPage, children }: Props) => {
  const { id, state, user } = upload;
  const uploadState: Record<UpdateUploadDtoStateEnum, string> = {
    DRAFT: "Draft",
    SUBMITTED: "Awaiting admin review",
    ADMIN_FEEDBACK: adminPage
      ? "Feedback sent to user"
      : "Feedback received from admin",
    USER_RESPONSE: adminPage
      ? "User response received"
      : "User response submitted",
    DONE: "Request Approved",
    DENIED: "Request Denied",
    PARTIAL_APPROVED: "Request Partially Approved",
  };

  return (
    <div className="my-space300 flex flex-col items-center">
      <div className="flex flex-col text-left">
        <Text tagName="h3" headingSize="m">
          Upload Request: ID{id}
        </Text>
        {adminPage && (
          <Text tagName="span" bodySize="m">
            Made by: {user.firstName} {user.lastName}
          </Text>
        )}
        <Text tagName="span" bodySize="m">
          Status: {uploadState[state]}
        </Text>
        <Text tagName="span" bodySize="m">
          Last Modified: {formatDateTime(upload.updatedAt)}
        </Text>
        {!children && upload.assignee?.firstName && (
          <Text tagName="span" bodySize="m">
            Assigned to: {upload.assignee.firstName} {upload.assignee.lastName}
          </Text>
        )}
        {children}
      </div>
    </div>
  );
};

export default UploadTitle;
